const Menu = () => {
  const header = document.getElementById('js-header')
  const menuBtn = document.getElementById('js-sidebar-nav-btn')
  const bookBtn = document.getElementById('js-book-btn')
  const sidebarMenu = document.getElementById('js-sidebar')
  const html = document.getElementsByTagName('html')[0]

  const toggleHeader = () => {
    header.classList.toggle('header--inverted')
    header.classList.toggle('header--standard')
    menuBtn.classList.toggle('burger--blur')
    menuBtn.classList.toggle('burger--solid')
    bookBtn.classList.toggle('btn--blur')
    bookBtn.classList.toggle('btn--solid')
  }

  menuBtn.addEventListener('click', (e) => {
    menuBtn.classList.toggle('js--pressed')
    sidebarMenu.classList.toggle('js--active')
    html.classList.toggle('js--noscroll')

    if (header.classList.contains('header--inverted')) {
      // toggleHeader()
    }
  })

  const headerHeight = header.offsetHeight
  let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop

  window.addEventListener('scroll', function () {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop

    if (
      currentScrollPos > prevScrollPos &&
      currentScrollPos > headerHeight &&
      header.classList.contains('header--inverted')
    ) {
      // toggleHeader()
    } else if (
      currentScrollPos === 0 &&
      header.classList.contains('header--home')
    ) {
      // toggleHeader()
    }

    prevScrollPos = currentScrollPos
  })
}

export default Menu
